import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import './styles/index.css';
import './styles/spinner.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './styles/circularProgress.css';
import reducers from './redux/reducers';
import * as serviceWorker from './serviceWorker';
import AppRouter from './routes/AppRouter';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';

const middlewares = [thunk];

if (process.env.NODE_ENV !== 'production') {
  //middlewares.push(logger);
}

const store = createStore(reducers, applyMiddleware(...middlewares));

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    useNextVariants: true
  }
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <AppRouter store={store} />
  </MuiThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
